import { Box, Grid, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import PhotoCarousel from "./PhotoCarousel";

export default function Details() {
  const theme = useTheme();

  const [images, setImages] = useState([]);

  useEffect(() => {
    let i = 1;
    const baseUrl =
      "https://minio-api.byerline.me/public-bucket/adventure-playhouse-pictures/carousel-";
    const loadImages = async () => {
      const loaded = [];

      while (true) {
        console.log(loaded);
        const url = `${baseUrl}${i}.jpg`;
        try {
          const res = await fetch(url, { method: "HEAD" });
          if (!res.ok) break;
          loaded.push(url);
          i++;
        } catch (e) {
          break;
        }
      }

      setImages(loaded);
    };

    loadImages();
  }, []);

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        px: 10,
        py: 4,
        bgcolor: theme.palette.primary.main,
        textAlign: "center",
      }}
    >
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          {images.length > 0 && <PhotoCarousel images={images} />}
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: "bold",
              color: theme.palette.custom.white,
            }}
          >
            The Adventure
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.custom.white }}
          >
            Get ready for epic adventures in this playhouse! The mighty Fort
            Knight is fully equipped with a rock wall, ladder, two stories, and
            an armory, making it a spectacular spot for your next quest! Its
            durability is Scout tested and Scout approved.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: "bold",
              color: theme.palette.custom.white,
            }}
          >
            The craft
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.custom.white }}
          >
            We tapped into our childhood imaginations to create the playhouse of
            every kid’s dreams! Our one-of-a-kind, timeless fort is perfect to
            play in now, and will keep its value to resell later. Room for
            plenty of friends at 8’6" x 11’6" x 12' and built out of
            pressure-treated wood with galvanized screws—this fort will hold up
            to years of play.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: "bold",
              color: theme.palette.custom.white,
            }}
          >
            The source
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.custom.white }}
          >
            adVenture Playhouses builds support San Diego local Venture Crew
            324, part of Scouting America, the hands and minds behind each
            playhouse edition. 100% of the proceeds go to our crew members,
            enabling us to support and fund our own adventures.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
